import { TAvailableRoutesTitles } from '@types'
import React, { useState } from 'react'
import { useNavigationEntries } from '@hooks'
import styled from '@emotion/styled'
import { colors, Icon, IconButton, Logo, Row, Space, Title } from 'common-components'
import { Popover } from 'antd'

import { NavEntriesList } from './partials'

const Container = styled(Row)`
  width: 100%;
  max-width: 1235px;
  margin: 0 auto;
  padding: 1em;
`

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.6em;
  padding: 32px 40px 32px 40px;
  background: #fff;
  border-radius: 16px;
  max-width: 1235px;
  margin: auto;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 1em;
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 0.6em;
  }
`

export const NavBar: React.FC = () => {
  const [selectedRoute, setSelectedRoute] = useState<TAvailableRoutesTitles>('projects')

  const { firstColumn, secondColumn } = useNavigationEntries()

  const allColumns = [...firstColumn.entries, ...secondColumn.entries]

  const content = (
    <Wrapper>
      <NavEntriesList
        heading={'Insert text'}
        setSelectedRoute={setSelectedRoute}
        entries={firstColumn.entries}
        selectedRoute={selectedRoute}
        iconColor={firstColumn.config.iconColor}
      />
      <NavEntriesList
        heading={'Insert text'}
        setSelectedRoute={setSelectedRoute}
        entries={secondColumn.entries}
        selectedRoute={selectedRoute}
        iconColor={secondColumn.config.iconColor}
      />
    </Wrapper>
  )

  return (
    <Container justify={'space-between'}>
      <Space size={25} align={'center'}>
        <Logo preview={false} width={82} />
        <Popover content={content}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              gap: 12,
            }}
          >
            <IconButton
              size='sm'
              icon={allColumns.find((column) => column.route === selectedRoute).icon}
              iconProps={{
                color: allColumns.find((column) => column.route === selectedRoute).iconColor,
                width: 24,
                height: 24,
              }}
              style={{ borderColor: colors.gray100, padding: 8 }}
            />
            <Title level={5}>
              {allColumns.find((column) => column.route === selectedRoute).title}
            </Title>
            <Icon icon={'ChevronDown'} color={colors.gray500} size={20} />
          </div>
        </Popover>
      </Space>
    </Container>
  )
}
